// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"Carousel_Carousel__2xUZK","elementContainer":"Carousel_elementContainer__303P3","element":"Carousel_element__2HBDA","hide":"Carousel_hide__nblyC"};